import React, { useState } from 'react';
import { Text, Button, Input, VStack, useToast } from '@chakra-ui/react';
import { careerApi } from './careerApi';
import { AuthShell } from './Signup';

export default function ForgotPassword() {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await careerApi.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      toast({ title: 'Failed', description: err.message, status: 'error' });
    }
    setBusy(false);
  }
  if (sent) return <AuthShell title="Check your inbox"><Text color="#4A5568">If an account exists for {email}, we've sent a reset link.</Text></AuthShell>;
  return (
    <AuthShell title="Forgot your password?">
      <form onSubmit={submit}>
        <VStack spacing="12px" align="stretch">
          <Input placeholder="Email" size="md" type="email" required value={email} onChange={e => setEmail(e.target.value)} />
          <Button type="submit" bg="#3730A3" color="white" _hover={{ bg: '#312E81' }} isLoading={busy}>Send reset link</Button>
        </VStack>
      </form>
    </AuthShell>
  );
}
